<template>
  <async-data :request-state="requestState">
    <slot name="default" v-bind:metadata="metadata"
          v-if="requestState === 'Success'">
      <!--WithMetadata body-->
    </slot>
  </async-data>
</template>

<script>
  import AsyncData from "../../Ui/AsyncData";
  import {RequestState} from "../../../requestState";
  import {mapActions} from "vuex";

  export default {
    name: 'with-metadata',
    components: {
      AsyncData,
    },
    props: {
      table: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {}
    },
    mounted() {
      this
        .metadataGetIfRequired({table: this.table, id: this.id})
        .then(response => {
          this.$emit('loaded', response.metadata)
        })
    },
    methods: {
      ...mapActions({
        metadataGetIfRequired: 'metadataGetIfRequired',
      })
    },
    computed: {
      metadataSection() {
        return this.$store.getters.getMetadataSection(this.table, this.id)
      },
      requestState() {
        if (!this.metadataSection) {
          return RequestState.NotPerformed
        }

        return this.metadataSection.requestState
      },
      metadata() {
        return this.metadataSection.response.metadata
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/WithMetadata.vue